import styles from './form.module.scss';
import React from 'react';

interface OwnProps {
    children: React.ReactNode;
}

export function Form({children}: OwnProps) {
    return <div className={styles.form}>{children}</div>;
}
